import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var CardSpacer = function CardSpacer() {
  return /*#__PURE__*/React.createElement("div", {
    className: cn('component'),
    "data-t-id": "cards-CardSpacer"
  });
};